import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IFinalScore, IGenericCatalog, IGenericItem } from 'src/interfaces'
import { IJobTypeCertitication, IJobTypeSkill } from 'src/interfaces/ISkills'

export interface CatalogState {
    jobTypes: IGenericItem[],
    certifications: IJobTypeCertitication[],
    skills: IJobTypeSkill[],
    softskills: IJobTypeSkill[],
    workplaces: IGenericItem[],
    days: IGenericItem[],
    jobDuration: IGenericItem[],
    interview: IGenericCatalog[],
    expLevel: object[],
    jobModality: IGenericItem[],
    workersType: IGenericItem[],
    portfolio: IGenericCatalog[],
    timeZones: IGenericItem[],
    feedbackScores: IFinalScore[],
    meetProviders: IGenericItem[],
}

const initialState: CatalogState = {
    jobTypes: [],
    certifications: [],
    skills: [],
    softskills: [],
    workplaces: [],
    days: [],
    jobDuration: [],
    interview: [],
    expLevel: [],
    jobModality: [],
    workersType: [],
    portfolio: [],
    timeZones: [],
    feedbackScores: [],
    meetProviders: []
}

export const catalogSlice = createSlice({
    name: 'catalog',
    initialState,
    reducers: {
        setJobTypes(state, action: PayloadAction<IGenericItem[]>) {
            state.jobTypes = action.payload
        },
        setCertifications(state, action: PayloadAction<IJobTypeCertitication[]>) {
            state.certifications = action.payload
        },
        setJobDuration(state, action: PayloadAction<IGenericItem[]>){
            state.jobDuration = action.payload
        },
        setJobModality(state, action: PayloadAction<IGenericItem[]>){
            state.jobModality = action.payload
        },
        setWorkplaces(state, action: PayloadAction<IGenericItem[]>){
            state.workplaces = action.payload
        },
        setWorkerTypes(state, action: PayloadAction<IGenericItem[]>){
            state.workersType = action.payload
        },
        setPortfolio(state, action: PayloadAction<IGenericCatalog[]>){
            state.portfolio = action.payload
        },
        setDays(state, action: PayloadAction<IGenericItem[]>){
            state.days = action.payload
        },
        setSkills(state, action: PayloadAction<IJobTypeSkill[]>){
            state.skills = action.payload
        },
        setSoftSkills(state, action: PayloadAction<IJobTypeSkill[]>){
            state.softskills = action.payload
        },
        setInterviewDurations(state, action: PayloadAction<IGenericCatalog[]>){
            state.interview = action.payload
        },
        setTimeZones(state, action: PayloadAction<IGenericItem[]>){
            state.timeZones = action.payload
        },
        setFeedbackScores(state, action: PayloadAction<[IFinalScore]>){
            state.feedbackScores = action.payload
        },
        clearJobCatalogs(state: CatalogState){
            state.jobTypes = []
            state.certifications = []
            state.skills = []
            state.softskills = []
            state.workplaces = []
            state.days = []
            state.jobDuration = []
            state.interview = []
            state.workersType = []

        },

        setMeetProviders(state, action: PayloadAction<IGenericItem[]>){
            state.meetProviders = action.payload
        },
    }
})

export const {
    setJobTypes, setCertifications, setJobDuration, setJobModality, setWorkplaces,
    setDays, setSkills, setSoftSkills, setInterviewDurations, setTimeZones,
    setWorkerTypes, setFeedbackScores, setPortfolio, clearJobCatalogs, setMeetProviders
} = catalogSlice.actions

export default catalogSlice.reducer